import { defineNuxtRouteMiddleware } from "#imports";
import { dklsLoader } from "#staxmpc/lib/dkls";

export default defineNuxtRouteMiddleware(async () => {
  console.log("load wasm");
  await dklsLoader;
});
